<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column label="序列号" align="center" prop="id" sortable width="150"/>
      <el-table-column label="订单号" align="center" prop="listno" sortable width="150"/>
      <el-table-column label="代理商id" align="center" prop="agentId" sortable width="150"/>
      <el-table-column label="地址" align="center" prop="siteName" sortable width="150"/>
      <el-table-column label="会员id" align="center" prop="vipName" sortable width="150"/>
      <el-table-column label="兑换积分数" align="center" prop="points" sortable width="150"/>
      <el-table-column label="创建时间" align="center" prop="crtdate" sortable width="150"/>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
  import { listOrder } from '../../api/order'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '添加',
        editForm: {
          id: 0,
          siteId:0,
          agentId:0,
          vipId:0,
          siteName: '',
          vipName: '',
          points: 1,
          crtdate: 1,
          page: 1,
          limit: 10,
          token: localStorage.getItem('logintoken')
        },
        // rules表单验证
        rules: {
          code: [{ required: true, message: '请输入', trigger: 'blur' }],
          name: [{ required: true, message: '请输入', trigger: 'blur' }],
          adds: [{ required: true, message: '请输入', trigger: 'blur' }]
        },
        formInline: {
          page: 1,
          limit: 10,
          token: localStorage.getItem('logintoken')
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    mounted() {
      this.getdata(this.editForm)
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取列表
      getdata(parameter) {
        this.loading = true
        parameter.limit= this.formInline.limit
        parameter.size= this.formInline.page
        // parameter.limit=5;
        // parameter.page=1;
        console.log("parameter:"+JSON.stringify(parameter))
        /***
         * 调用接口，注释上面模拟数据 取消下面注释
         */
        listOrder(parameter)
          .then(res => {
            console.log("parameter:"+parameter)
            this.loading = false
            if (res.status != 1) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.data.list
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.limit
              this.pageparm.total = res.data.count
              console.log("分页参数："+this.pageparm.currentPage+","+this.pageparm.pageSize+","+this.pageparm.total)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('菜单加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      }
    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
</style>





// WEBPACK FOOTER //
// src/views/order/Order.vue